import React from "react";

const Footer = () => (
  <footer className="admin-footer">
    <span>&copy; {new Date().getFullYear()} SPIN Management Portal</span>
    <span><i className="fas fa-shield-alt" /> Unified and secure administration</span>
  </footer>
);

export default Footer;
